import { render, staticRenderFns } from "./CategoryAttributeEdit.vue?vue&type=template&id=40f0f5f0&"
import script from "./CategoryAttributeEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryAttributeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports